import { makeAutoObservable } from 'mobx';
import { validateBreakCandleType } from './validateBreakCandleType';

export class BreakCandleTypeData {
  candleDuration = 1;
  breakBy = 0;
  candleColor = '';
  candleType = 'LAST';
  filterForToday = false;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }
  //common methods
  resetToDefaults = () => {
    this.candleDuration = 1;
    this.breakBy = 0;
    this.candleColor = '';
    this.candleType = 'LAST';
    this.filterForToday = false;
  };

  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const data = {
      candleDuration: this.candleDuration,
      breakBy: this.breakBy,
      candleColor: this.candleColor,
      candleType: this.candleType,
      filterForToday: this.filterForToday,
    };
    const result = validateBreakCandleType(data);
    return result;
  };

  returnJson = () => {
    return {
      candleDuration: this.candleDuration,
      breakBy: this.breakBy,
      candleColor: this.candleColor,
      candleType: this.candleType,
      filterForToday: this.filterForToday,
    };
  };
  //specific methods
  setCandleDuration = (number) => {
    this.candleDuration = number;
  };
  setBreakBy = (number) => {
    this.breakBy = number;
  };
  setCandleColor = (string) => {
    this.candleColor = string;
  };
  setCandleType = (string) => {
    this.candleType = string;
  };
  setFilterForToday = (bool) => {
    this.filterForToday = bool;
  };
}
